import type { DeliveryInstruction } from './interfaces'

export type Result<T, E> = { type: 'ok'; value: T } | { type: 'err'; error: E }

export function matchResult<T, E, R>(
  result: Result<T, E>,
  handlers: {
    ok: (value: T) => R
    err: (error: E) => R
  },
): R {
  return result.type === 'ok' ? handlers.ok(result.value) : handlers.err(result.error)
}

export const isCustomDeliveryInstruction = (value: DeliveryInstruction): boolean =>
  ['Other', 'Neighbour'].includes(value)
